export type { LemonBadgeProps } from './LemonBadge'
export { LemonBadge } from './LemonBadge'
